module.exports = __webpack_public_path__ + "img/yes.0882eb46.svg";